import useCustomColors from "../../../hooks/useCustomColors"
import { loadCustomColors, saveCustomColors } from "../helpers/storage"

const useRodgColors = ({ resetOnMount = false } = {}) =>
  useCustomColors(loadCustomColors, saveCustomColors, { resetOnMount })

export default useRodgColors
